// src/App.js
import React, { useState, useEffect } from "react";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUsPage";
import ContactUsPage from "./pages/ContactUsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

// Import the global styles sheet
import "./styles.css";

const App = () => {
  const [currentPage, setCurrentPage] = useState("home");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  return (
    <div className="min-h-screen bg-gray-100 font-inter text-gray-800 flex flex-col">
      {/* The CDN links for Font Awesome and Google Fonts are in public/index.html */}
      {/* The Tailwind CSS CDN script is also in public/index.html */}

      <NavBar setCurrentPage={setCurrentPage} currentPage={currentPage} />
      <main className="flex-grow">
        {currentPage === "home" && <HomePage />}
        {currentPage === "about" && <AboutUsPage />}
        {currentPage === "contact" && <ContactUsPage />}
        {currentPage === "privacy" && <PrivacyPolicyPage />}
      </main>
      <Footer setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default App;

//asdfdf
